'use strict';

angular.module('shiftTraderApp')
  .controller('EmployeeScheduleCtrl', function ($scope, me, upcomingWorkPeriods, selectedUser, $rootScope, $stateParams, $location, $timeout, TimeService, $filter) {
    $rootScope.$broadcast('setTopNavTitle', 'Schedule');
    $scope.upcomingWorkPeriods = upcomingWorkPeriods;
    $scope.me = me;
    $scope.selectedUser = selectedUser;
    $scope.isToTrade = _.has($stateParams, 'toTrade') && !_.isNull($stateParams['toTrade']) && !_.isUndefined($stateParams['toTrade']);
    $scope.currentWeek = TimeService.getWeekTwixFromMoment(TimeService.getNowInStoreTime());
    $scope.todayDate = TimeService.getNowInStoreTime();

    if ($scope.isToTrade) {
      $scope.upcomingWorkPeriods = _.where($scope.upcomingWorkPeriods, function(wp) {
        return wp.start_time.unix() >= $scope.todayDate.unix();
      });
    }


    if ($filter('publishedShifts')($scope.upcomingWorkPeriods).length > 0) {

      var maxStartDate = _.max(
          _.where($scope.upcomingWorkPeriods, function(x) {return x.$isPublished();}),
        function(wp) {
          return wp.start_time.unix();
        }).start_time;

      var arrayOfWeeks = (function() {
        var weeks, loopWeek;
        loopWeek = $scope.currentWeek;
        weeks = [];

        do {
          weeks.push(loopWeek);
          loopWeek = moment(loopWeek.start).add(1,'weeks').twix(moment(loopWeek.end).add(1,'weeks'));
        } while ( maxStartDate.unix() > loopWeek.start.unix() );

        return weeks;
      }());

      //console.log(arrayOfWeeks);


      $scope.workPeriodsByWeek = _.map(arrayOfWeeks, function(weekTwix) {
        var totalHours = 0
        var workPeriods = _.sortBy(_.where($scope.upcomingWorkPeriods, function(wp) {
          var passes = wp.$isPublished() && weekTwix.contains(wp.start_time) &&
              weekTwix.overlaps(wp.range_twix) &&
              weekTwix.intersection(wp.range_twix).length('minutes') > 0;

          if (passes) {
            totalHours += wp.range_twix.length('minutes') / 60.0
          }

          return passes
        }), '_startTimeUnix')

        return {
          weekTwix: weekTwix,
          workPeriods: workPeriods,
          totalHours: totalHours.toFixed(1)
        };
      });

      $scope.objectsToRender = (function() {
        var beginningOfFamine;
        var objList = [];
        _.each($scope.workPeriodsByWeek, function(weekObj, idx, collection) {
          if (weekObj.workPeriods.length > 0) {
            if (!_.isUndefined(beginningOfFamine) && !_.isNull(beginningOfFamine)) {
              objList.push({
                type: 'emptyRegion',
                range_twix: moment(beginningOfFamine).twix(moment(collection[idx-1].weekTwix.end).subtract(12, 'hours'))
              });
              beginningOfFamine = undefined;
            }

            weekObj.type = 'standard';
            objList.push(weekObj);
          } else {
            if (_.isUndefined(beginningOfFamine) || _.isNull(beginningOfFamine)) {
              beginningOfFamine = weekObj.weekTwix.start;
            }
          }
        });
        return objList;
      }());
    }


    //console.log($scope.workPeriodsByWeek);

    $scope.mySchedule = (function() {
      if ($scope.selectedUser.length > 0) {
        return $scope.selectedUser.id === me.id;
      } else {
        return true;
      }
    })();

    if ($scope.mySchedule) {
      if ($scope.isToTrade) {
        $rootScope.$broadcast('setTopNavTitle', 'Shift Your Schedule');
      } else {
        $rootScope.$broadcast('setTopNavTitle', 'My Schedule');
      }

    } else {
      $rootScope.$broadcast('setTopNavTitle', $scope.selectedUser[0].first_name + '\'s Schedule');
    }

    $scope.goToWorkPeriod = function(wp) {
      wp._highlight = true;
      if ($scope.isToTrade) {
        // use .url so that the query params get stripped
        $location.url('setupTrade/' + wp.id);
      } else {
        $location.path('workPeriod/' + wp.id);
      }
    };

    $scope.getLinkUrl = function(wp) {
      if ($scope.isToTrade) {
        return '#/setupTrade/' + wp.id;
      } else {
        return '#/workPeriods/' + wp.id;
      }
    };

//    $timeout(function() {
//      var colorBars = $('.week_line');
//      colorBars.each(function (i, e) {
//        var bar = $(e);
//        var next = $(colorBars[i + 1]);
//        console.log(bar);
//
//        bar.scrollToFixed({
//          marginTop: 0,
//          limit: function () {
//            var limit = 0;
//            if (next) {
//              limit = $(next).offset().top;
//            }
//            return limit;
//          }, 'z-index': 1001
//        });
//      });
//    }, 300);
  });
